import rootReducer from './rootReducer'
import { configureStore } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import { apiSlice } from '../api/slice'

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
})

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // This prop fixes an error we have on the reducers 👇
      // A non-serializable value was detected in the state, in the path: `web3.balance`. Value: Big {s: 1, e: 0, c: Array(1)}
      // If @redux/toolkit is upgraded, change to https://stackoverflow.com/a/63244831
      serializableCheck: false,
    }).concat(apiSlice.middleware),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
})

export default store
